import React from "react";
import VideoEmbed from "./VideoEmbed";
import { sanitizeHtml } from "../helpers/misc/sanitizeHtml";
const VideoEmbedWithCaption = (props) => (<div>
		<VideoEmbed videoClassName={props.videoClassName} embedSrc={props.embedSrc} coverImage={props.coverImage} shouldFireClevertapEvent={props.shouldFireClevertapEvent} clevertapFireLocation={props.clevertapFireLocation} imgWidth={props.imgWidth} imgWidths={props.imgWidths} sizeString={props.sizeString}/>
		<div className={props.captionClassName} dangerouslySetInnerHTML={{ __html: sanitizeHtml(props.caption) }}/>
	</div>);
export default VideoEmbedWithCaption;
